var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChristmasFacebookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.195 33.8302C6.12 32.3852 0 25.4151 0 17.0001C0 7.65004 7.65 0 17 0C26.35 0 34 7.65004 34 17.0001C34 25.4151 27.88 32.3852 19.805 33.8302L18.87 33.0652H15.13L14.195 33.8302Z",
    fill: "#DFBA5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.63 21.76L24.395 16.9999H19.89V13.6849C19.89 12.3249 20.4 11.3049 22.44 11.3049H24.65V6.96988C23.46 6.79988 22.1 6.62988 20.91 6.62988C17 6.62988 14.28 9.00989 14.28 13.2599V16.9999H10.03V21.76H14.28V33.745C15.215 33.915 16.15 34 17.085 34C18.02 34 18.955 33.915 19.89 33.745V21.76H23.63Z",
    fill: "#026A6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasFacebookLogo);
export default __webpack_public_path__ + "static/media/christmas_facebook_logo.5c6266c8c19a8ab2ca41ec42d8ee28f0.svg";
export { ForwardRef as ReactComponent };